import { render } from "./CardProductsComponent.vue?vue&type=template&id=32fbcde1"
import script from "./CardProductsComponent.vue?vue&type=script&lang=js"
export * from "./CardProductsComponent.vue?vue&type=script&lang=js"

import "./CardProductsComponent.vue?vue&type=style&index=0&id=32fbcde1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__